import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from '../Base';
import { Header } from '../Header';
import { Footer } from '../Footer';
import OrganChart from "./OrganChart";
import Flowchart from "flowchart-react";

export default class OrganCharts extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'organchart',
            data: null,
            loading: true,
            id_to_remove: null,
            page: 1,
            per_page: 30,
            phrase: ''
        };
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({
            component: <OrganChart Caller={this} Id={id} />
        });
    }
    onAdd(parentId) {
        this.removeKeyDown();
        this.showComponents({
            component: <OrganChart Caller={this} ParentId={parentId} />
        });
    }
    componentDidMount() {
        this.refreshData();
    }
    renderForm() {
        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">گره های چارت سازمانی</h3>
                            <div className="nk-block-des text-soft">
                                <p>شما {this.money(this.state.data.recordsCount)} گره ثبت شده دارید</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        {this.state.data.recordsCount <= 0 ?
                            <div className="card-inner-group">
                                <div className="example-alert">
                                    <div className="alert alert-pro alert-warning">
                                        <div className="alert-text">
                                            <h6>توجه</h6>
                                            <p>در حال حاضر چارتی برای شرکت شما ایجاد نشده است</p>
                                            <a onClick={e => this.onAdd(this.defaultGuid())} className="btn btn-primary"><em className="icon ni ni-download-cloud"></em><span>افزودن گره اصلی</span></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            <div className="card-inner-group">
                                <div className="card-inner position-relative card-tools-toggle">
                                    <div className="card-title-group">
                                        <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                            <div className="form-inline flex-nowrap gx-3">
                                                <div className="form-wrap">
                                                    <input type="text" defaultValue={this.state.phrase} onChange={e => this.state.phrase = e.target.value} placeholder="عنوان" className="form-control" />
                                                </div>
                                                <div className="btn-wrap">
                                                    <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em class="icon ni ni-search"></em> جستجو</button></span>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div className="card-inner p-0">
                                    <div className="nk-tb-list nk-tb-ulist">
                                        <div className="nk-tb-item nk-tb-head">
                                            <div className="nk-tb-col"><span className="sub-text">ردیف</span></div>
                                            <div className="nk-tb-col"><span className="sub-text">عنوان</span></div>
                                            <div className="nk-tb-col"><span className="sub-text">پست سازمان</span></div>
                                            <div className="nk-tb-col"><span className="sub-text">کارگروه سازمان</span></div>
                                            <div className="nk-tb-col text-end"><span className="sub-text">عملیات</span></div>
                                        </div>
                                        {this.state.data.records.map((record, index) =>
                                            <div className="nk-tb-item">
                                                <div className="nk-tb-col">
                                                    <span className="sub-text">{this.genRowNumber(index)}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text">{record.title}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text">{record.positionTitle}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text">{record.workingGroupTitle}</span>
                                                </div>
                                                <div className="nk-tb-col text-end">
                                                    <a className="hand text-warning mx-1" onClick={e => this.onAdd(record.id)}><span style={{ "display": "inline-block" }}>زیرشاخه</span></a>
                                                    <a className="hand text-primary mx-1" onClick={e => this.onEdit(record.id)}><span style={{ "display": "inline-block" }}>ویرایش</span></a>
                                                    <a className="hand text-danger mx-1" onClick={e => this.confirmRemove(record.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove"><span style={{ "display": "inline-block" }}>حذف</span></a>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {this.createPaging()}
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />,
                this.renderPopupComponent(),
            ];

        return contents;
    }
}